import { useState } from "react";
import { Maximize2 } from "lucide-react";
import Lightbox from "../Lightbox";
import { FadeUp, SectionHead } from "../Reveal";
import { GALLERY_IMAGES } from "../../data/machines";

const SPANS = [
  "col-span-2 aspect-[4/3] lg:row-span-2 lg:aspect-auto",
  "aspect-[4/3]",
  "aspect-[4/3]",
  "col-span-2 aspect-[2/1] lg:aspect-auto",
  "aspect-[4/3]",
  "aspect-[4/3]",
  "aspect-[4/3]",
  "aspect-[4/3]",
];

export default function Gallery() {
  const [index, setIndex] = useState(null);

  const show = (i) => setIndex(i);
  const close = () => setIndex(null);
  const prev = () => setIndex((i) => (i - 1 + GALLERY_IMAGES.length) % GALLERY_IMAGES.length);
  const next = () => setIndex((i) => (i + 1) % GALLERY_IMAGES.length);

  return (
    <section id="galeri" className="scroll-mt-24 bg-paper py-20 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-8">
        <SectionHead
          eyebrow="Galeri"
          title="Sahadan Kareler"
          desc="Makinelerimizin sahadaki gücünü yakından görün. Fotoğrafa tıklayarak büyük ekranda inceleyebilirsiniz."
        />

        <div className="mt-12 grid grid-cols-2 gap-3 lg:grid-cols-4 lg:gap-4">
          {GALLERY_IMAGES.map((image, i) => (
            <button
              key={image.src}
              type="button"
              onClick={() => show(i)}
              data-testid={`gallery-item-${i}`}
              aria-label={`${image.alt} — büyüteçte aç`}
              className={`group relative overflow-hidden rounded-lg bg-ink ${SPANS[i]}`}
            >
              <img
                src={image.src}
                alt={image.alt}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.05]"
              />
              <span className="absolute inset-0 bg-ink-deep/0 transition-colors duration-300 group-hover:bg-ink-deep/25" />
              <span className="absolute right-3 top-3 grid h-9 w-9 place-items-center rounded-full bg-paper/90 text-ink opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                <Maximize2 size={15} />
              </span>
              <span className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-ink-deep/70 to-transparent p-3 pt-10 text-left font-mono text-[10px] uppercase tracking-[0.18em] text-paper/90 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                {image.caption}
              </span>
            </button>
          ))}
        </div>
      </div>

      <Lightbox
        images={GALLERY_IMAGES}
        index={index}
        onClose={close}
        onPrev={prev}
        onNext={next}
      />
    </section>
  );
}